module.exports = __webpack_public_path__ + "img/product-header.78777ec4.svg";